import { QueryFunctionContext } from '@tanstack/react-query'
import { DELETE, GET, POST, PUT } from '../../../redux/middleware/types'
import backendRequest from '../../../services/api/backendRequest'
import budgetDriversEndpoints from '../api/budgetDriversEndpoints'
import budgetDriversQueryKeys from '../queries/budgetDriversQueryKeys'
import { BudgetDriver } from '../../../types/budgetDriver/BudgetDriver'

export const fetchBudgetDrivers = async ({
  queryKey: [{ companyId }],
  signal
}: QueryFunctionContext<ReturnType<(typeof budgetDriversQueryKeys)['list']>>): Promise<BudgetDriver[]> => {
  if (!companyId) return []
  return backendRequest<BudgetDriver[]>({
    method: GET,
    url: budgetDriversEndpoints.list(companyId),
    signal
  })
}

export const createBudgetDriver = async (data: BudgetDriver, companyId: string): Promise<BudgetDriver> => {
  return backendRequest<BudgetDriver>({
    method: POST,
    url: budgetDriversEndpoints.list(companyId),
    data
  })
}

export const updateBudgetDriver = async (data: BudgetDriver, companyId: string): Promise<BudgetDriver> => {
  return backendRequest<BudgetDriver>({
    method: PUT,
    url: budgetDriversEndpoints.detail(companyId, data.id),
    data
  })
}

export const deleteBudgetDriver = async (id: number, companyId: string): Promise<BudgetDriver> => {
  return backendRequest<BudgetDriver>({
    method: DELETE,
    url: budgetDriversEndpoints.detail(companyId, id)
  })
}

export const updateBudgetDriverOrders = async (
  orders: Array<{ id: number; order: number }>,
  companyId: string
): Promise<BudgetDriver[]> => {
  return backendRequest<BudgetDriver[]>({
    method: PUT,
    url: budgetDriversEndpoints.order(companyId),
    data: orders
  })
}
